import { render, staticRenderFns } from "./EventStormingModelElement.vue?vue&type=template&id=5b0d1f3c&"
import script from "./EventStormingModelElement.vue?vue&type=script&lang=js&"
export * from "./EventStormingModelElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports